import get from 'lodash/get';
import type {
  DateLocale,
  MixedLocale,
  NumberLocale,
  StringLocale,
} from 'yup/lib/locale';
import type { Message } from 'yup/lib/types';

import { VGL_ERROR_CODE } from '@/services/errorHandler/errorCodes';
import { VglError } from '@/services/errorHandler/vglError';
import { getLocaleDateString } from '@/utils/dates/dates';
import { ArrayLocale } from 'yup/lib/locale';

interface LocaleObject {
  date: DateLocale;
  number: NumberLocale;
  mixed: MixedLocale;
  string: StringLocale;
  array: ArrayLocale;
}

export const locales: LocaleObject = {
  date: {
    max: (params) =>
      `Das Datum darf nicht nach dem ${getLocaleDateString(
        params.max,
      )} liegen.`,
    min: (params) =>
      `Das Datum darf nicht vor dem ${getLocaleDateString(params.min)} liegen.`,
  },

  number: {
    min: 'Der Wert muss mindestens ${min} betragen.',
    max: 'Der Wert darf maximal ${max} sein.',
    integer: 'Bitte nur ganze Zahlen eingeben.',
  },

  mixed: {
    required: 'Bitte füllen Sie das Pflichtfeld aus.',
    oneOf: 'Muss einer der folgenden Werte sein: ${values}',
    notOneOf: 'Bitte füllen Sie das Pflichtfeld aus.',
    notType: 'Bitte füllen Sie das Pflichtfeld aus.',
  },

  string: {
    max: (params) =>
      `Es dürfen maximal ${params.max} Zeichen eingetragen werden.`,
    email: 'Bitte geben Sie eine gültige E-Mail ein.',
  },

  array: {
    min: (params) => `Bitte wählen Sie mindestens ${params.min} Eintrag aus.`,
    max: (params) =>
      `Es dürfen maximal ${params.max} Einträge ausgewählt werden.`,
  },
};

export const getMessage = (path: string): Message => {
  const message = get(locales, path);
  if (message !== undefined) {
    return message;
  }
  throw new VglError(VGL_ERROR_CODE.VALIDATION_MISSING_LOCALE, {
    additionalErrorMessage: `Path: ${path}`,
  });
};
